import request from '@/utils/request'

let Ma_check_itemApi = {

  /*检查项管理列表*/
  list(data) {
    return request._post('/shop/plus.ma_check_item.Index/index', data);
},
/*添加检查项管理*/
add(data) {
    return request._post('/shop/plus.ma_check_item.Index/add', data);
},
/*修改检查项管理*/
edit(data) {
    return request._post('/shop/plus.ma_check_item.Index/edit', data);
},
/*删除检查项管理*/
del(data) {
    return request._post('/shop/plus.ma_check_item.Index/del', data);
},
/*检查项管理详情*/
detail(data) {
  return request._post('/shop/plus.ma_check_item.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.ma_check_item.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.ma_check_item.Setting/getSetting', data, errorback);
    },
}
export default Ma_check_itemApi;



// WEBPACK FOOTER //
// ./src/api/ma_check_item.js